import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Outlet, Link as RouterLink, useLocation } from "react-router-dom";

import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import Header from "./Header";

const BaseLayout = ({ children }) => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isLoginPage = location.pathname === "/auth/login";

  useEffect(() => {
    //console.log(location.pathname);
    //setValue(getIdx(location.pathname));
    //console.log(value);
  }, []);

  // Jika halaman login, kembalikan layout original tanpa perubahan
  if (isLoginPage) {
    return (
      <Box
        sx={{
          flex: 1,
          height: "100%",
          backgroundColor: "#000",
        }}
      >
        {children || <Outlet />}
      </Box>
    );
  }

  // Layout untuk halaman selain login dengan perbaikan mobile
  return (
    <Box
      sx={{
        flex: 1,
        height: "100%",
        minHeight: "100vh", // Minimal full viewport height
        backgroundColor: "#000",
        // Untuk mobile, bg menutupi area
        ...(isMobile && {
          minHeight: "100dvh", // Dynamic viewport height untuk mobile
          position: "relative",
        }),
      }}
    >
      <Box
        sx={{
          backgroundColor: "#000",
          //position: "sticky",
          top: 0,
          //zIndex: theme.zIndex.appBar,
          // Untuk mobile
          ...(isMobile && {
            minHeight: "160px",
            paddingBottom: "8px",
          }),
        }}
      >
        <Header />
      </Box>
      
      <Box
        sx={{
          // Container untuk konten utama
          backgroundColor: "#fff", // Warna background konten
          minHeight: isMobile ? "calc(100vh - 168px)" : "calc(100vh - 160px)", // Sesuaikan dengan tinggi header
        }}
      >
        {children || <Outlet />}
      </Box>
    </Box>
  );
};

BaseLayout.propTypes = {
  children: PropTypes.node,
};

export default BaseLayout;